module.exports = __webpack_public_path__ + "static/media/M-animada.83c33164.gif";